// extracted by mini-css-extract-plugin
export default {"decoration":"Decoration_decoration__c2BGR"};